import { render, staticRenderFns } from "./TheLoader.vue?vue&type=template&id=3a43baa8&scoped=true"
import script from "./TheLoader.vue?vue&type=script&lang=js"
export * from "./TheLoader.vue?vue&type=script&lang=js"
import style0 from "./TheLoader.vue?vue&type=style&index=0&id=3a43baa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a43baa8",
  null
  
)

export default component.exports